import * as React from 'react'
import { IBuildedTourGroup, IWeeklyOtaReservation } from 'utils/weeklyTypes'
import { DEFAULT_GUIDE_FILTER_OPTIONS } from 'static/constants'
import { IGuideFilterOptions } from 'static/interfaces'

export const GROUP_CATEGORY = {
  TOUR_GROUP: 'ツアーグループ',
  CANCELED: 'キャンセル済のゲスト',
  UNASSIGNED: 'グループ未アサインのゲスト',
} as const

interface ITourDrawerContextValue {
  selectedGroupName: string | null
  setSelectedGroupName: React.Dispatch<React.SetStateAction<string | null>>
  selectedTourGroup: IBuildedTourGroup | null
  setSelectedTourGroup: React.Dispatch<React.SetStateAction<IBuildedTourGroup | null>>
  selectedOtaReservations: IWeeklyOtaReservation[]
  setSelectedOtaReservations: React.Dispatch<React.SetStateAction<IWeeklyOtaReservation[]>>
  orderDesc: boolean
  setOrderDesc: React.Dispatch<React.SetStateAction<boolean>>
  justAssignedOtaReservations: IWeeklyOtaReservation[]
  setJustAssignedOtaReservations: React.Dispatch<React.SetStateAction<IWeeklyOtaReservation[]>>
  groupSelectingResource: string | null
  setGroupSelectingResource: React.Dispatch<React.SetStateAction<string | null>>
  groupSelectedId: number | null
  setGroupSelectedId: React.Dispatch<React.SetStateAction<number | null>>
  showGuides: boolean
  setShowGuides: React.Dispatch<React.SetStateAction<boolean>>
  guideFilterOptions: IGuideFilterOptions
  setGuideFilterOptions: React.Dispatch<React.SetStateAction<IGuideFilterOptions>>
}

const TourDrawerContext = React.createContext<ITourDrawerContextValue | undefined>(undefined)

interface ITourDrawerProviderProps {
  children: React.ReactNode
  groupSelectingResource: string | null
  setGroupSelectingResource: React.Dispatch<React.SetStateAction<string | null>>
  groupSelectedId: number | null
  setGroupSelectedId: React.Dispatch<React.SetStateAction<number | null>>
}

export const TourDrawerProvider: React.VFC<ITourDrawerProviderProps> = ({
  children,
  groupSelectingResource,
  setGroupSelectingResource,
  groupSelectedId,
  setGroupSelectedId,
}) => {
  const [selectedGroupName, setSelectedGroupName] = React.useState<string | null>(null)
  const [selectedTourGroup, setSelectedTourGroup] = React.useState<IBuildedTourGroup | null>(null)
  const [selectedOtaReservations, setSelectedOtaReservations] = React.useState<
    IWeeklyOtaReservation[]
  >([])
  const [orderDesc, setOrderDesc] = React.useState<boolean>(true)
  const [justAssignedOtaReservations, setJustAssignedOtaReservations] = React.useState<
    IWeeklyOtaReservation[]
  >([])
  const [showGuides, setShowGuides] = React.useState<boolean>(false)
  const [guideFilterOptions, setGuideFilterOptions] = React.useState<IGuideFilterOptions>(
    DEFAULT_GUIDE_FILTER_OPTIONS
  )

  const value: ITourDrawerContextValue = {
    selectedGroupName,
    setSelectedGroupName,
    selectedTourGroup,
    setSelectedTourGroup,
    selectedOtaReservations,
    setSelectedOtaReservations,
    orderDesc,
    setOrderDesc,
    justAssignedOtaReservations,
    setJustAssignedOtaReservations,
    groupSelectingResource,
    setGroupSelectingResource,
    groupSelectedId,
    setGroupSelectedId,
    showGuides,
    setShowGuides,
    guideFilterOptions,
    setGuideFilterOptions,
  }

  return <TourDrawerContext.Provider value={value}>{children}</TourDrawerContext.Provider>
}

export const useTourDrawerContext = (): ITourDrawerContextValue => {
  const context = React.useContext(TourDrawerContext)

  if (!context) {
    throw new Error('useTourDrawerContext must be used within TourDrawerProvider')
  }

  return context
}
